import { Link } from "react-router-dom";
import { useAuth } from "../auth/AuthContext.jsx";

/* A member who follows a link to an administrator's page. They are signed
   in and allowed here — just not for that — so this says which it is. */
export function DeniedPage() {
  const { user } = useAuth();
  return (
    <div className="page narrow">
      <div className="pagehead">
        <div>
          <h2 className="pagetitle">Administrators only</h2>
          <p className="pagesub">
            You are signed in as <span className="mono">{user?.email}</span>, which
            is a member account. Managing who has access is an administrator’s
            job.
          </p>
        </div>
        <Link className="btn btn-sm btn-solid" to="/">
          Back to the board
        </Link>
      </div>
    </div>
  );
}
